import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../../components/panel/panel.jsx";
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "react-datetime/css/react-datetime.css";
import "react-datepicker/dist/react-datepicker.css";
import Joi from "joi";
import Form from "../../../common/form.jsx";
import auth from "../../../services/authservice";
import withRouter from "../../../common/withRouter.jsx";
import { connect } from 'react-redux';
import { loadCurrentUser } from '../../../store/users';
import { getAction, saveAction } from "../../../services/forumcategories.js";
import { fetchForumCount } from '../../../store/count'; // Import the action

const apiUrl = process.env.REACT_APP_API_URL;
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Handle = Slider.Handle;

class ForumCategory extends Form {
    constructor(props) {
        super(props);
        this.state = {
            maxDateDisabled: true,
            isEditable: true,
            users: [],
            taskCategories: [], // Add state for task categories
            data: {
                user: "",
                name: "",
                description: "",
                status: "",
            },
            errors: {},
        };

        this.statusOptions = [
            { value: "in progress", label: "In Progress" },
            { value: "pending", label: "Pending" },
            { value: "active", label: "Active" },
            { value: "archive", label: "Archive" },
        ];

        this.handleSlider = (props) => {
            const { value, dragging, index, ...restProps } = props;
            return (
                <Tooltip prefixCls="rc-slider-tooltip" overlay={value} visible={dragging} placement="top" key={index}>
                    <Handle value={value} {...restProps} />
                </Tooltip>
            );
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    async populateStatus() {
        this.statusoptions = this.statusOptions.map((option) => (
            <option key={option.label} value={option.value}>
                {option.value}
            </option>
        ));
    }

    async populateCategory() {
        try {
            const catId = this.props.params.id;
            if (catId === "new") return;
            const { data: cat } = await getAction(catId);
            this.setState({ data: this.mapToViewModel(cat) });
            console.log(this.state.data);
        } catch (ex) {
            console.log(ex)
            if (ex.response && ex.response.status === 404) this.props?.history?.replace("/error");
        }
    }

    async componentDidMount() {
        document.title = "Add Forum Category";
        await this.populateCategory();
        await this.populateStatus();
    }

    schema = Joi.object({
        name: Joi.string().required(),
        description: Joi.string().required(),
        status: Joi.any().required(),
    });

    doSubmit = async () => {
        console.log("Submitting data:", this.state.data);
        const user = auth.getProfile();
        const data = { ...this.state.data };

        if (this.props.params.id === "new") {
            data.user = user?._id;
        } else {
            data.user = data?.user?._id || data.user;
        }

        try {
            console.log("Final data to save:", data);
            await saveAction(data);

            // Dispatch fetchForumCount after successful creation
            if (this.props.fetchForumCount && this.props.params.id === "new") {
                this.props.fetchForumCount();
            }

            if (this.props.navigate) this.props.navigate("/forum/forumcategories");
            else if (this.props.history) this.props.history.push("/forum/forumcategories");
        } catch (ex) {
            console.error("Error saving forum category:", ex);
            if (ex.response) {
                const errors = { ...this.state.errors };
                errors.status = ex.response.data;
                this.setState({ errors });
                alert("Failed to save forum category. Please check the form and try again.");
            }
        }
    };


    mapToViewModel(cat) {
        return {
            _id: cat._id,
            user: cat.user,
            name: cat.name,
            description: cat.description,
            status: cat.status,
        };
    }



    render() {
        const { data, errors } = this.state;
        return (
            <React.Fragment>
                <div>
                    <ol className="breadcrumb float-xl-right">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/forum/forumcategories">ForumCategories</Link>
                        </li>
                        <li className="breadcrumb-item active">Add Forum Category</li>
                    </ol>
                    <h1 className="page-header">
                        Add Forum Category <small>Forum Category-registration-form</small>
                    </h1>

                    <div className="row">
                        <div className="col-xl-10">
                            <Panel>
                                <PanelHeader>Add Forum Category</PanelHeader>
                                <PanelBody className="panel-form">
                                    <form className="form-horizontal form-bordered" onSubmit={this.handleSubmit}>
                                        {this.renderInput(
                                            "name",
                                            "Name",
                                            "text",
                                            "Enter Name"
                                        )}
                                        {/* {this.renderInput("description", "Description", "text", "Enter Description")} */}
                                        {this.renderTextarea("description", "Description", "Enter Description")}

                                        <div className="form-group row">
                                            <label className="col-lg-4 col-form-label" htmlFor="status">
                                                Status
                                            </label>
                                            <div className="col-lg-8">
                                                <select
                                                    name="status"
                                                    id="status"
                                                    value={data.status}
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Status</option>
                                                    {this.statusoptions}
                                                </select>
                                            </div>
                                            {errors.status && <div className="alert alert-danger">{errors.status}</div>}
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-lg-8">
                                                <button
                                                    type="submit"
                                                    disabled={this.validate}
                                                    className="btn btn-primary width-65"
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </PanelBody>
                            </Panel>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    currentUser: state.entities.users.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
    loadCurrentUser: (id) => dispatch(loadCurrentUser(id)),
    fetchForumCount: () => dispatch(fetchForumCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForumCategory));
